/**
 * JavaScript pour mettre à jour dynamiquement le widget PayPal Pay Later
 * lorsque le prix du produit change (variante, quantité, etc.)
 */

(function() {
  'use strict';

  /**
   * Met à jour le montant affiché dans le widget
   */
  function updatePayPalWidget() {
    const widgets = document.querySelectorAll('.paypal-pay-later-widget');
    
    widgets.forEach(function(widget) {
      const sectionId = widget.dataset.sectionId;
      const installments = 4; // Fixe à 4 échéances
      
      // Récupérer le prix actuel depuis le prix affiché sur la page
      const priceElement = document.querySelector(`#price-${sectionId} .price, #price-${sectionId} .money, .product-price, [id*="price-${sectionId}"] .price`);
      
      if (!priceElement) {
        // Fallback : utiliser le prix stocké dans data-product-price
        const storedPrice = widget.dataset.productPrice;
        if (storedPrice) {
          const priceInCents = parseInt(storedPrice);
          const priceInEuros = priceInCents / 100;
          updateMessage(widget, priceInEuros, installments);
        }
        return;
      }
      
      // Extraire le prix depuis le texte
      const priceText = priceElement.textContent || '';
      // Chercher un nombre avec éventuellement des espaces, virgules ou points
      const priceMatch = priceText.match(/[\d\s,\.]+/);
      
      if (!priceMatch) {
        // Fallback : utiliser le prix stocké
        const storedPrice = widget.dataset.productPrice;
        if (storedPrice) {
          const priceInCents = parseInt(storedPrice);
          const priceInEuros = priceInCents / 100;
          updateMessage(widget, priceInEuros, installments);
        }
        return;
      }
      
      // Convertir le prix en nombre (gérer les virgules, points et espaces)
      let priceString = priceMatch[0].replace(/\s/g, '').replace(',', '.');
      // Si plusieurs points/virgules, garder seulement le dernier comme séparateur décimal
      const parts = priceString.split(/[.,]/);
      if (parts.length > 2) {
        priceString = parts.slice(0, -1).join('') + '.' + parts[parts.length - 1];
      }
      const priceInEuros = parseFloat(priceString);
      
      if (isNaN(priceInEuros) || priceInEuros <= 0) {
        // Fallback : utiliser le prix stocké
        const storedPrice = widget.dataset.productPrice;
        if (storedPrice) {
          const priceInCents = parseInt(storedPrice);
          const priceInEuros = priceInCents / 100;
          updateMessage(widget, priceInEuros, installments);
        }
        return;
      }
      
      updateMessage(widget, priceInEuros, installments);
    });
  }

  /**
   * Récupère le symbole de la currency actuelle
   */
  function getCurrentCurrencySymbol(callback) {
    // Essayer de récupérer depuis le panier
    fetch('/cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        if (cart && cart.currency && cart.currency.symbol) {
          callback(cart.currency.symbol);
        } else {
          // Fallback : chercher dans les éléments de la page
          const currencyElement = document.querySelector('[data-currency-symbol]');
          if (currencyElement) {
            const symbol = currencyElement.getAttribute('data-currency-symbol');
            if (symbol) {
              callback(symbol);
              return;
            }
          }
          
          // Fallback : chercher le symbole dans les prix affichés
          const priceElement = document.querySelector('.price, .money, [class*="price"]');
          if (priceElement) {
            const priceText = priceElement.textContent || '';
            // Chercher des symboles de currency connus
            if (priceText.includes('€')) {
              callback('€');
              return;
            } else if (priceText.includes('$')) {
              callback('$');
              return;
            } else if (priceText.includes('£')) {
              callback('£');
              return;
            }
          }
          
          // Par défaut : €
          callback('€');
        }
      })
      .catch(function(error) {
        console.warn('[PayPal Pay Later] Erreur lors de la récupération de la currency:', error);
        callback('€');
      });
  }

  /**
   * Met à jour le message du widget
   */
  function updateMessage(widget, priceInEuros, installments) {
    // Calculer le montant par échéance
    const installmentAmount = priceInEuros / installments;
    
    // Formater le montant (retirer les décimales .0)
    let installmentAmountFormatted = installmentAmount.toFixed(2);
    installmentAmountFormatted = installmentAmountFormatted.replace(/\.0+$/, '');
    installmentAmountFormatted = installmentAmountFormatted.replace('.', ',');
    
    // Mettre à jour le message
    const headline = widget.querySelector('.paypal-pay-later__headline');
    if (!headline) {
      return;
    }
    
    // Détecter la langue
    const locale = headline.dataset.locale || 'fr';
    const isEnglish = locale === 'en';
    
    // Récupérer les textes selon la langue
    const textBefore = isEnglish 
      ? (headline.dataset.textBeforeEn || '')
      : (headline.dataset.textBeforeFr || '');
    const textAfter = isEnglish
      ? (headline.dataset.textAfterEn || '')
      : (headline.dataset.textAfterFr || '');
    
    // Récupérer le symbole de la currency
    getCurrentCurrencySymbol(function(currencySymbol) {
      // Construire le message selon la position du symbole
      // Pour USD ($), le symbole est avant le montant sans espace
      // Pour EUR (€) et GBP (£), le symbole est après le montant avec espace
      let message;
      if (currencySymbol === '$') {
        if (textBefore) {
          message = textBefore + ' ' + currencySymbol + installmentAmountFormatted;
        } else {
          message = currencySymbol + installmentAmountFormatted;
        }
        if (textAfter) {
          message = message + ' ' + textAfter;
        }
      } else {
        if (textBefore) {
          message = textBefore + ' ' + installmentAmountFormatted + ' ' + currencySymbol;
        } else {
          message = installmentAmountFormatted + ' ' + currencySymbol;
        }
        if (textAfter) {
          message = message + ' ' + textAfter;
        }
      }
      headline.textContent = message;
      headline.dataset.currencySymbol = currencySymbol;
    });
  }

  /**
   * Initialise le widget
   */
  function initPayPalWidget() {
    // Mettre à jour au chargement
    updatePayPalWidget();
    
    // Observer les changements de prix
    const observer = new MutationObserver(function(mutations) {
      let shouldUpdate = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          const target = mutation.target;
          if (target && (
            target.classList.contains('price') ||
            target.classList.contains('money') ||
            target.closest('.price') ||
            target.closest('#price-')
          )) {
            shouldUpdate = true;
          }
        }
      });
      
      if (shouldUpdate) {
        // Attendre un peu pour que le prix soit complètement mis à jour
        setTimeout(updatePayPalWidget, 100);
      }
    });
    
    // Observer les changements dans les éléments de prix
    document.querySelectorAll('.price, .money, [id*="price"]').forEach(function(element) {
      observer.observe(element, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
    
    // Écouter les événements de changement de variante
    document.addEventListener('variant:change', updatePayPalWidget);
    document.addEventListener('price:change', updatePayPalWidget);
  }

  // Initialiser au chargement de la page
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPayPalWidget);
  } else {
    initPayPalWidget();
  }
})();

